export const YOUTUBE_API_KEY = 'AIzaSyCrrucRr4U7xjtlq9rUPe7ruHVr_G3BiEk';
// const HtmlWebpackPlugin = require('html-webpack-plugin');
// const webpack = require('webpack'); //to access built-in plugins

// module.exports = {
//   module: {
//     rules: [{ test: /\.txt$/, use: 'raw-loader' }],
//   },
//   plugins: [new HtmlWebpackPlugin({ template: './../components/indexdesktopsearch.html' })],
// };
